<template>
  <d-modal
    :modal="modal"
    :title="
      editMode ? $t('tokens.edit.page-heading') : $t('tokens.add.page-heading')
    "
    @submitModal="handleSubmitModal"
    @closeModal="handleCloseModal"
    :isSubmitting="isSubmitting"
  >
    <template slot="body">
      <d-loading class="mb-4" v-if="loading.page"></d-loading>
      <v-row class="mb-1" v-else>
        <v-col cols="12" class="mb-3">
          <d-date-picker
            :label="$t('tokens.add.form.expired')"
            hide-details="auto"
            filled
            v-model="form.expiredAt"
          ></d-date-picker>
        </v-col>
        <v-col cols="12" class="mb-3">
          <p class="mb-0 body-2">{{ $t("tokens.add.form.expired-hint") }}</p>
        </v-col>
      </v-row>
    </template>
  </d-modal>
</template>
  
  <script>
import { addToken, updateToken } from "@/services/token";

import ProjectAuthenticationTypes from "@/enums/ProjectAuthenticationTypes.js";

const initialForm = {
  id: null,
  expiredAt: null,
};

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    item: Object,
  },
  data() {
    return {
      ProjectAuthenticationTypes,
      isSubmitting: false,
      form: { ...initialForm },
      loading: {
        page: false,
      },
    };
  },
  computed: {
    editMode() {
      return !!this.item?.id;
    },
  },
  methods: {
    async handleSubmitModal() {
      if (this.editMode) {
        await this.submitUpdateToken();
        return;
      }
      await this.submitAddToken();
    },
    async submitAddToken() {
      try {
        this.isSubmitting = true;
        await addToken(this.form);

        this.$eventBus.$emit("notification", {
          type: "success",
          message: this.$t("tokens.add.alert.added"),
        });
        this.$emit("submitModal");
      } catch {
        this.$eventBus.$emit("notification", {
          type: "error",
          message: this.$t("defaults.text.request-error"),
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async submitUpdateToken() {
      try {
        this.isSubmitting = true;
        await updateToken(this.form);

        this.$eventBus.$emit("notification", {
          type: "success",
          message: this.$t("tokens.edit.alert.updated"),
        });
        this.$emit("submitModal");
      } catch {
        this.$eventBus.$emit("notification", {
          type: "error",
          message: this.$t("defaults.text.request-error"),
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    handleCloseModal() {
      this.$emit("closeModal");
    },
  },
  async mounted() {
    try {
      this.loading.page = true;
      if (this.item) {
        this.form = {
          id: this.item?.id,
          expiredAt: this.item?.expiredAt,
        };
      }
    } finally {
      this.loading.page = false;
    }
  },
};
</script>
  